var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.191,
    height: 7.524,
    viewBox: "0 0 10.191 7.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;stroke:#208ce1;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.1,18.807,8.531,24.38a.227.227,0,0,1-.325,0L5.094,21.268a.227.227,0,0,1,0-.325l.488-.488a.227.227,0,0,1,.325,0l2.461,2.461,4.922-4.922a.227.227,0,0,1,.325,0l.488.488A.227.227,0,0,1,14.1,18.807Z",
    transform: "translate(-4.525 -17.425)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/TickIcon.49a565fc1f740bd12be658296bff76b1.svg";
export { ForwardRef as ReactComponent };